import styled from 'styled-components';
import StatGaugeCard from 'shared/components/commonComponentsMC/controllers/StatGaugeCard';

const MetricCircles = ({ metrics }) => {
  if (!metrics || metrics.length === 0) return null;

  return (
    <Row>
      {metrics.map(({ label, value, unit, icon, ratio }, i) => (
        <StatGaugeCard
          key={i}
          title={label}
          value={value ?? '--'}
          unit={unit}
          icon={icon}
          ratio={ratio ?? 0}
        />
      ))}
    </Row>
  );
};

export default MetricCircles;

const Row = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  gap: 8px;
  padding: 12px 20px;
  flex-wrap: wrap;
`;
